import React from "react";
import { Form } from "react-bootstrap";

const UserTypeFilter = ({ body, setBody, userTypeFilterOptionArr,filterType = "role"}) => {
  return (
      <Form.Select
      className="select text-muted"
      aria-label="Default select example"
      defaultValue={body.role}
      value={body.role}
      onChange={(e) =>
        setBody((p) => ({
          ...p,
          [filterType]: e.target.value,
        }))
      }
    >
      {userTypeFilterOptionArr?.map((option) => (
        <option value={option.value}>{option.label}</option>
      ))}
    </Form.Select>
  );
};

export default UserTypeFilter;
